const WEEKLY_WITHOUT_TRIAL_PLAN = 'weeklyWithoutTrial';
const WEEKLY_WITH_WEEK_PAID_TRIAL_PLAN = 'weeklyWithWeekPaidTrial';
const MONTHLY_WITH_PAID_TRIAL_PLAN = 'monthlyWithPaidTrial';
const MONTHLY_WITH_MONTH_PAID_TRIAL_PLAN = 'monthlyWithMonthPaidTrial'
const MONTHLY_WITHOUT_TRIAL_PLAN = 'monthlyWithoutTrial';
const QUARTERLY_WITH_QUARTER_PAID_TRIAL_PLAN = 'quarterlyWithQuarterPaidTrial';
const QUARTERLY_WITHOUT_TRIAL_PLAN = 'quarterlyWithoutTrial';
const WEEKLY_999_WITHOUT_TRIAL_PLAN = 'weekly999WithoutTrial';
const WEEKLY_499_WITHOUT_TRIAL_PLAN = 'weekly499WithoutTrial';
const WEEKLY_999_WITH_WEEK_750_TRIAL_PLAN = 'weekly999WithWeek750Trial';
const WEEKLY_499_WITH_WEEK_375_TRIAL_PLAN = 'weekly499WithWeek375Trial';
const WEEKLY_499_WITH_WEEK_349_TRIAL_PLAN = 'weekly499WithWeek349Trial';
const MONTHLY_3999_WITH_1999_TRIAL_PLAN = 'monthly3999With1999Trial';
const MONTHLY_3999_WITH_MONTH_2999_TRIAL_PLAN = 'monthly3999WithMonth2999Trial'
const MONTHLY_3999_WITHOUT_TRIAL_PLAN = 'monthly3999WithoutTrial';
const MONTHLY_1999_WITHOUT_TRIAL_PLAN = 'monthly1999WithoutTrial';
const MONTHLY_1999_WITH_MONTH_1499_TRIAL_PLAN = 'monthly1999WithMonth1499Trial';
const MONTHLY_1999_WITH_MONTH_1399_TRIAL_PLAN = 'monthly1999WithMonth1399Trial';
const QUARTERLY_7999_WITH_QUARTER_5999_TRIAL_PLAN = 'quarterly7999WithQuarter5999Trial';
const QUARTERLY_7999_WITHOUT_TRIAL_PLAN = 'quarterly7999WithoutTrial';
const QUARTERLY_3999_WITHOUT_TRIAL_PLAN = 'quarterly3999WithoutTrial';
const QUARTERLY_3999_WITH_QUARTER_2999_TRIAL_PLAN = 'quarterly3999WithQuarter2999Trial';
const QUARTERLY_3999_WITH_QUARTER_2799_TRIAL_PLAN = 'quarterly3999WithQuarter2799Trial';

export {
    WEEKLY_999_WITHOUT_TRIAL_PLAN,
    WEEKLY_999_WITH_WEEK_750_TRIAL_PLAN,
    WEEKLY_499_WITHOUT_TRIAL_PLAN,
    WEEKLY_499_WITH_WEEK_375_TRIAL_PLAN,
    WEEKLY_499_WITH_WEEK_349_TRIAL_PLAN,
    MONTHLY_3999_WITH_1999_TRIAL_PLAN,
    MONTHLY_3999_WITHOUT_TRIAL_PLAN,
    MONTHLY_3999_WITH_MONTH_2999_TRIAL_PLAN,
    MONTHLY_1999_WITHOUT_TRIAL_PLAN,
    MONTHLY_1999_WITH_MONTH_1499_TRIAL_PLAN,
    MONTHLY_1999_WITH_MONTH_1399_TRIAL_PLAN,
    QUARTERLY_7999_WITHOUT_TRIAL_PLAN,
    QUARTERLY_7999_WITH_QUARTER_5999_TRIAL_PLAN,
    QUARTERLY_3999_WITHOUT_TRIAL_PLAN,
    QUARTERLY_3999_WITH_QUARTER_2999_TRIAL_PLAN,
    QUARTERLY_3999_WITH_QUARTER_2799_TRIAL_PLAN,
    WEEKLY_WITHOUT_TRIAL_PLAN,
    WEEKLY_WITH_WEEK_PAID_TRIAL_PLAN,
    MONTHLY_WITH_PAID_TRIAL_PLAN,
    MONTHLY_WITHOUT_TRIAL_PLAN,
    MONTHLY_WITH_MONTH_PAID_TRIAL_PLAN,
    QUARTERLY_WITHOUT_TRIAL_PLAN,
    QUARTERLY_WITH_QUARTER_PAID_TRIAL_PLAN
};
